"use client";

import { useState } from "react";

const toggleBtn = {
  position: "absolute",
  right: "0.5rem",
  top: "50%",
  transform: "translateY(-50%)",
  padding: "0.35rem",
  border: "none",
  background: "transparent",
  cursor: "pointer",
  color: "#64748b",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "8px",
  lineHeight: 0,
};

function IconEye() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}

function IconEyeOff() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24" />
      <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68" />
      <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61" />
      <line x1="2" x2="22" y1="2" y2="22" />
    </svg>
  );
}

/** Password input with show / hide control (matches `.ed-input` styling). */
export function PasswordVisibilityField({
  value,
  onChange,
  onFocus = undefined,
  onPointerDown = undefined,
  onMouseDown = undefined,
  onTouchStart = undefined,
  onKeyDown = undefined,
  placeholder,
  autoComplete,
  name = undefined,
  ariaLabel,
  className = "ed-input",
  disabled = false,
  readOnly = false,
  style,
  inputStyle,
  /** When true, show invalid styling (policy mismatch) without relying on :invalid / submit. */
  invalid = false,
}) {
  const [visible, setVisible] = useState(false);
  return (
    <div style={{ position: "relative", width: "100%", ...style }}>
      <input
        className={className}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onPointerDown={onPointerDown}
        onMouseDown={onMouseDown}
        onTouchStart={onTouchStart}
        onKeyDown={onKeyDown}
        type={visible ? "text" : "password"}
        placeholder={placeholder}
        autoComplete={autoComplete}
        name={name}
        aria-label={ariaLabel}
        aria-invalid={invalid || undefined}
        disabled={disabled}
        readOnly={readOnly}
        style={{
          ...inputStyle,
          paddingRight: "2.75rem",
          ...(invalid
            ? {
                borderColor: "rgba(220, 38, 38, 0.55)",
                boxShadow: "0 0 0 3px rgba(220, 38, 38, 0.12)",
              }
            : null),
        }}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        disabled={disabled}
        aria-label={visible ? "Hide password" : "Show password"}
        aria-pressed={visible}
        style={{
          ...toggleBtn,
          opacity: disabled ? 0.55 : 1,
          cursor: disabled ? "not-allowed" : "pointer",
        }}
      >
        {visible ? <IconEyeOff /> : <IconEye />}
      </button>
    </div>
  );
}
